import axios from './mayiRequest'

/**
 * 通过榜单id搜索房屋
 * @param {Array} ids 榜单id集合
 */
export function fetchHouseIds({ ids }) {
  return axios.post('/feapi/mayipromotionweb/mayibingo/h5/promotion/cms/getextenddata', arguments[0])
}
/**
 * 通过房屋id获取房屋详情
 * @param {Array} houseIdList 房屋id集合
 */
export function fetchHouseDetail({ houseIdList, noNeedPrice, needUnactive, needNoRepositoty }) {
  return axios.post('/feapi/mayipromotionweb/mayibingo/h5/promotion/search/searchhousebyhouseidlist', arguments[0])
}
